// extracted by mini-css-extract-plugin
module.exports = {"stars-container":"Stars_stars-container__F5a21","yellow":"Stars_yellow__IZbYZ","dark-yellow":"Stars_dark-yellow__IH5gl"};